import { ListBase, useListContext } from "ra-core";
import { ListPagination } from "@/components/admin/list-pagination";
import { AddTask } from "../tasks/AddTask";
import { TasksIterator } from "../tasks/TasksIterator";
import type { Deal, Task } from "../types";

export const ProjectTasks = ({ project }: { project: Deal }) => (
  <section className="space-y-4">
    {!project.archived_at && <AddTask project={project} selectContact />}
    <ListBase
      resource="tasks"
      filter={{ deal_id: project.id }}
      sort={{ field: "due_date", order: "ASC" }}
      perPage={25}
      disableSyncWithLocation
      storeKey={false}
    >
      <ProjectTaskList />
    </ListBase>
  </section>
);

function ProjectTaskList() {
  const { total, isPending, error, filterValues, setFilters } =
    useListContext<Task>();
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span className="text-sm text-muted-foreground">
          Задачи проекта{total != null ? ": " + total : ""}
        </span>
        <label className="text-sm flex gap-2 items-center">
          Статус
          <select
            aria-label="Статус задач проекта"
            className="rounded-md border bg-background px-3 py-2"
            value={filterValues.status ?? "all"}
            onChange={(event) => {
              const { status: _status, ...other } = filterValues;
              setFilters(
                event.target.value === "all"
                  ? other
                  : { ...other, status: event.target.value },
                undefined,
                false,
              );
            }}
          >
            <option value="all">Все</option>
            <option value="new">Новые</option>
            <option value="in_progress">В работе</option>
            <option value="completed">Выполненные</option>
          </select>
        </label>
      </div>
      {error ? (
        <p role="alert">Не удалось загрузить задачи проекта.</p>
      ) : isPending ? (
        <p>Загрузка задач…</p>
      ) : total === 0 ? (
        <p className="text-sm text-muted-foreground">
          Задач с выбранным статусом нет.
        </p>
      ) : (
        <TasksIterator showCompleted showContact showAssignee />
      )}
      {!isPending && !error && !!total && <ListPagination />}
    </div>
  );
}
